import ValueSuggestion from './ValueSuggestion';

export default ValueSuggestion;